module.exports = __webpack_public_path__ + "media/img/apple-icon-114x114-c282068a3f3e2761a0dbe42566e142a4.png";